module.exports = __webpack_public_path__ + "img/global.fea6d6ab.png";